<template>
  <div class="swiper" ref="root">
    <div
      class="swiper-slide"
      v-for="(item, index) in banners"
      :key="index + item.img"
      :date="item.date"
      :txt="item.txt"
      ref="slides"
      :data-video="!!item.video"
    >
      <div class="content-wrapper">
        <video v-if="item.video" muted preload="true" :src="item.video" class="picture" ref="videoEls" />
        <www-picture class="picture" :img="item.img" :w="isMobile ? 750 : 1440" :h="800" :fullScreen="true" :noCompress="true" />
      </div>
      <div class="mask" v-if="item.video"></div>
      <div class="describe" :class="item.video ? 'describe-video' : ''">
        <div class="main">{{ $t("desc") }}</div>
        <div class="sub" v-if="$isCN()">{{ enSub }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
const DIAPLAY_TIME = 3.5;
const TRANSITION_TIME = 1.5;
export default {
  i18n: {
    messages: {
      zh: {
        desc: "中国二手车行业的\nAI应用基础设施",
      },
      en: {
        desc: "Al Application Infrastructure\nfor China's\nUsed Car Industry",
      },
    },
  },
  data() {
    return {
      useHomeEffect: true,
      currentIndex: 0,
    };
  },
  computed: {
    enSub() {
      if (!this.isMobile) {
        return "Al Application Infrastructure for China's Used Car Industry";
      }
      // return "Dedicated Enabler to\nChina's Auto Merchants";
      return "Al Application Infrastructure\nfor China's\nUsed Car Industry";
    },
    isMobile() {
      return this.$store.state.isMobileSite;
    },
    banners() {
      if (this.isMobile) {
        return [
          {
            img: "//assets-dfc.souche.com/2066708951177584640.jpg",
          },
          {
            img: "//res-fengche.souche.com/bolt/SESnCg0LXfa409pktfIyb/%E7%A7%BB%E5%8A%A8%E7%AB%AF%E9%A6%96%E9%A1%B5banner2.jpg",
          },
          {
            img: "//res-fengche.souche.com/bolt/77aPa5iMd0kimh28KvESG/%E7%A7%BB%E5%8A%A8%E7%AB%AF%E9%A6%96%E9%A1%B5banner3.jpg",
          },
        ];
      }
      return [
        {
          img: "//assets-dfc.souche.com/2066708951453597696.jpg",
        },
        {
          img: "//assets-dfc.souche.com/2064646617235128320.jpg",
        },
        {
          img: "//assets-dfc.souche.com/2064646617407905792.jpg",
        },
      ];
    },
  },
  methods: {
    init() {
      const slides = this.$refs.slides;
      if (!slides.length) {
        return;
      }
      slides.forEach((slide, index) => {
        slide.style["z-index"] = index === this.currentIndex ? 3 : 1;
        if (index === 0) {
          this.addShowedAnimation(slide);
        }
      });
      this.toggleVideoState();
    },
    addShowedAnimation(slide) {
      const isCurrentVideoEl = slide.dataset.video;
      if (isCurrentVideoEl) {
        return;
      }
      if (slide.classAdded) {
        return;
      }
      slide.classAdded = true;
      gsap
        .fromTo(
          this.getEffectTarget(slide),
          {
            scale: 1,
            translateY: 0,
          },
          {
            scale: 1.1,
            translateY: "-15px",
            duration: DIAPLAY_TIME,
          }
        )
        .eventCallback("onComplete", () => {
          this.slideNext();
        });
    },
    removeShowedAnimation(slide) {
      slide.classAdded = false;
      slide.style.visibility = "hidden";
      this.getEffectTarget(slide).style.transform = "unset";
    },
    onChanged() {
      // const slides = this.$refs.slides;
      // if (!slides.length) {
      //   return;
      // }
      // slides.forEach((slide, index) => {
      //   if (index !== this.currentIndex) {
      //     this.removeShowedAnimation(slide);
      //   }
      // });
      // this.toggleVideoState();
    },
    getEffectTarget(slide) {
      return slide.querySelector(".content-wrapper");
    },
    slideNext() {
      clearTimeout(this.timeRef);
      const slides = this.$refs.slides;
      if (!slides.length) {
        return;
      }
      const preIndex = this.currentIndex;
      const preSlide = slides[preIndex];
      this.currentIndex = this.currentIndex + 1;
      if (this.currentIndex >= this.banners.length) {
        this.currentIndex = 0;
      }
      const that = this;
      // console.log("----");
      const isCurrentVideo = !!slides[this.currentIndex].dataset.video;
      // if (isCurrentVideo) {
      //   this.toggleVideoState();
      // }
      slides.forEach((slide, index) => {
        if (index === preIndex) {
          slide.style["z-index"] = 2;
          slide.style.visibility = "unset";
        } else if (index === this.currentIndex) {
          // that.removeShowedAnimation(slide);
          slide.style.visibility = "unset";
          slide.style["z-index"] = 3;
          const maskEl = slide.querySelector(".mask");
          maskEl && gsap.fromTo(maskEl, { opacity: 0 }, { opacity: 0.4, duration: 1 });
          gsap
            .fromTo(
              that.getEffectTarget(slide),
              {
                clipPath: "circle(0% at left top)",
              },
              {
                clipPath: "circle(142% at left top)",
                duration: TRANSITION_TIME,
              }
            )
            .eventCallback("onComplete", () => {
              that.removeShowedAnimation(preSlide);
              that.getEffectTarget(slide).style["clip-path"] = "unset";
              if (that.notInViewPort) {
                that.inViewPortAction = () => {
                  that.onChanged();
                  that.toggleVideoState();
                  if (isCurrentVideo) {
                    return;
                  }
                  that.addShowedAnimation(slide);
                };
                return;
              }
              that.onChanged();
              that.toggleVideoState();
              if (isCurrentVideo) {
                return;
              }
              that.addShowedAnimation(slide);
            });
        } else {
          slide.style["z-index"] = 1;
        }
      });
    },
    onScroll(inViewPort = false) {
      this.notInViewPort = !inViewPort;
      const slides = this.$refs.slides;
      if (!slides.length) {
        return;
      }
      if (inViewPort) {
        if (this.inViewPortAction) {
          this.inViewPortAction();
          this.inViewPortAction = null;
          return;
        }
      }
      const slideEl = slides[this.currentIndex];
      const isCurrentVideoEl = slideEl.dataset.video;
      if (inViewPort) {
        if (isCurrentVideoEl) {
          this.$store.commit("nav/setNav", { transparent: true, whiteStyle: true, iconWhite: false });
          if (this.$refs.videoEls[0].paused) {
            this.$refs.videoEls[0].play();
          }
        } else {
          this.$store.commit("nav/setNav", { transparent: true, whiteStyle: true, iconWhite: false });
        }
      } else {
        if (isCurrentVideoEl) {
          this.$refs.videoEls[0].pause();
        }
      }
    },
    videoPlayingFn() {
      const slides = this.$refs.slides;
      if (!slides.length) {
        return;
      }
      const slideEl = slides[this.currentIndex];
      const videoEl = slideEl.querySelector("video");
      videoEl.removeEventListener("ended", this.videoPlayingFn);
      this.slideNext();
    },
    toggleVideoState() {
      const slides = this.$refs.slides;
      if (!slides.length) {
        return;
      }
      const slideEl = slides[this.currentIndex];
      if (slideEl.dataset.video) {
        // this.$store.commit("nav/setNav", { transparent: true, whiteStyle: true });
        const videoEl = slideEl.querySelector("video");
        videoEl.play();
        videoEl.removeEventListener("ended", this.videoPlayingFn);
        videoEl.addEventListener("ended", this.videoPlayingFn);
      } else {
        // this.$store.commit("nav/setNav", { transparent: true, whiteStyle: false });
      }
    },
  },
  mounted() {
    this.$refs.root.style.height = !this.isMobile ? "100vh" : `${parseInt(window.innerWidth * 1.07, 10)}px`;
    this.videoPlayingFn = this.videoPlayingFn.bind(this);
    this.init();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.swiper {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.swiper-slide {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.active-animation {
  animation: kenburns-top 3s ease-out both;
}

/* ----------------------------------------------
     * Generated by Animista on 2023-3-11 16:34:0
     * Licensed under FreeBSD License.
     * See http://animista.net/license for more info. 
     * w: http://animista.net, t: @cssanimista
     * ---------------------------------------------- */

/**
     * ----------------------------------------
     * animation kenburns-top
     * ----------------------------------------
     */

@keyframes kenburns-top {
  0% {
    transform: scale(1) translateY(0);
    transform-origin: 50% 16%;
  }
  100% {
    transform: scale(1.1) translateY(-15px);
    transform-origin: top;
  }
}

.picture {
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  object-fit: cover;
}

.content-wrapper {
  width: 100vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(0, 0, 0);
}
.describe {
  position: absolute;
  top: 236px;
  left: 142px;
  display: flex;
  flex-direction: column;
  right: 32px;
  overflow: hidden;
  white-space: pre-line;
  color: #fff;

  .main {
    font-style: normal;
    font-size: 60px;
    font-weight: 600;
    line-height: 78px;
  }

  .sub {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    margin-top: 18px;
  }

  .btn {
    width: 177px;
    height: 48px;
    background: #ff571a;
    border-radius: 40px;
    margin-top: 124px;
    color: white;
    cursor: pointer;
  }
}

.describe-video {
  color: white;
}

@media screen and(max-width:540px) {
  .describe {
    position: absolute;
    top: 50px;
    left: 37px;
    display: flex;
    flex-direction: column;
    max-width: 90%;
    right: unset;
    overflow: hidden;
    white-space: pre-line;
    color: #fff;

    .main {
      font-size: 23px;
      line-height: 30px;
    }

    .sub {
      font-size: 11px;
      line-height: 18px;
      margin-top: 12px;
    }

    .btn {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-header/index.vue